import React, { useEffect, useState } from 'react';
import { useSessionState } from '../hooks/useSessionState';
import api from '../services/api';
import { getProyectos } from '../services/api';
import { BotonesDocumento, usePrint, ModalEmail } from '../components/PrintView';
import DocTemplate from '../components/PrintView';
import FiltroPanel from '../components/FiltroPanel';
import RibbonActions from '../components/RibbonActions';
import DocHistorialModal from '../components/DocHistorialModal';
import SalidaBodegaModal from '../components/SalidaBodegaModal';
import ProductoPicker from '../components/ProductoPicker';

const HIST_BTN = { display:'flex', alignItems:'center', justifyContent:'center', width:34, height:34, background:'#1e293b', border:'1px solid #334155', color:'#cbd5e1', borderRadius:8, cursor:'pointer', flexShrink:0 };
const ESTADOS = ['borrador','enviada','entregada','anulada'];
const EC = { borrador:'#94a3b8', enviada:'#3b82f6', entregada:'#10b981', anulada:'#ef4444' };

export default function Remisiones() {
  const [lista,     setLista]     = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [filtro,    setFiltro]    = useSessionState('rem_filtro', '');
  const [modal,     setModal]     = useState(false);
  const [saving,    setSaving]    = useState(false);
  const [form, setForm] = useState({ proyecto_id:'', cliente_id:'', fecha_entrega:'', lugar_entrega:'', notas:'', items:[{ descripcion:'', cantidad:1, unidad:'und', observaciones:'' }] });
  const [verHist, setVerHist] = useState(null);
  const [emailRem, setEmailRem] = useState(null);
  const [salidaRem, setSalidaRem] = useState(null);
  const [flash, setFlash] = useState(null);
  const [editId, setEditId] = useState(null);

  const imprimir = usePrint();

  const load = () => api.get('/remisiones', { params: filtro ? { estado: filtro } : {} }).then(r => setLista(r.data));

  const handlePrintRemision = async (r) => {
    const { data: full } = await api.get(`/remisiones/${r.id}`);
    imprimir(
      <DocTemplate
        tipo="REMISIÓN DE ENTREGA" numero={full.numero}
        fecha={new Date(full.created_at).toLocaleDateString('es-CO')}
        vence={full.fecha_entrega ? new Date(full.fecha_entrega).toLocaleDateString('es-CO') : null}
        cliente={full.cliente_nombre} proyecto={full.proyecto_nombre}
        items={full.items} notas={full.notas}
        campos={[{ label:'Lugar entrega', value: full.lugar_entrega || '—' }]}
      />
    );
  };

  useEffect(() => { load(); getProyectos().then(r => setProyectos(r.data)); }, []);
  useEffect(() => { load(); }, [filtro]);

  const selectedProy = proyectos.find(p => p.id === form.proyecto_id);

  const onProyecto = (id) => {
    const p = proyectos.find(x => x.id === id);
    setForm(f => ({ ...f, proyecto_id: id, cliente_id: p?.cliente_id || '' }));
  };

  const addItem = () => setForm(f => ({ ...f, items: [...f.items, { descripcion:'', cantidad:1, unidad:'und', observaciones:'', producto_id:null }] }));
  const removeItem = i => setForm(f => ({ ...f, items: f.items.filter((_,idx) => idx !== i) }));
  const updateItem = (i, k, v) => setForm(f => ({ ...f, items: f.items.map((it,idx) => idx === i ? {...it,[k]:v} : it) }));
  const patchItem = (i, patch) => setForm(f => ({ ...f, items: f.items.map((it,idx) => idx === i ? {...it,...patch} : it) }));
  // Al escribir libre se desliga del producto; al elegir del catálogo se enlaza y copia nombre/unidad.
  const itemDescText = (i, v) => patchItem(i, { descripcion: v, producto_id: null });
  const itemPick = (i, p) => patchItem(i, { descripcion: p.nombre, unidad: p.unidad || 'und', producto_id: p.id });

  const FORM_VACIO = { proyecto_id:'', cliente_id:'', fecha_entrega:'', lugar_entrega:'', notas:'', items:[{ descripcion:'', cantidad:1, unidad:'und', observaciones:'', producto_id:null }] };
  const nuevaRemision = () => { setEditId(null); setForm(FORM_VACIO); setModal(true); };
  const abrirEditar = async (r) => {
    try {
      const { data } = await api.get(`/remisiones/${r.id}`);
      setForm({
        proyecto_id: data.proyecto_id || '', cliente_id: data.cliente_id || '',
        fecha_entrega: data.fecha_entrega ? String(data.fecha_entrega).slice(0, 10) : '',
        lugar_entrega: data.lugar_entrega || '', notas: data.notas || '',
        items: (data.items || []).map(it => ({ descripcion: it.descripcion || '', cantidad: Number(it.cantidad) || 1, unidad: it.unidad || 'und', observaciones: it.observaciones || '', producto_id: it.producto_id || null })),
      });
      setEditId(r.id); setModal(true);
    } catch (e) { alert('No se pudo cargar la remisión'); }
  };

  const handleCreate = async () => {
    if (!form.proyecto_id || !form.cliente_id) return alert('Seleccione un proyecto');
    if (form.items.some(i => !i.descripcion)) return alert('Complete la descripción de todos los ítems');
    setSaving(true);
    try {
      if (editId) await api.put(`/remisiones/${editId}`, form);
      else await api.post('/remisiones', form);
      setModal(false); setEditId(null);
      setForm(FORM_VACIO);
      load();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const cambiarEstado = async (id, estado) => {
    await api.patch(`/remisiones/${id}/estado`, { estado });
    load();
  };

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Remisiones de Entrega</h1><p style={s.sub}>Control de entregas a clientes</p></div>
        <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <FiltroPanel
            fields={[{ tipo: 'select', label: 'Estado', value: filtro, onChange: setFiltro, capitalize: true, options: [{ value: '', label: 'Todas' }, ...ESTADOS.map(e => ({ value: e, label: e }))] }]}
            onClear={() => setFiltro('')}
          />
          <button style={s.btnPrimary} onClick={nuevaRemision}>+ Nueva remisión</button>
        </div></RibbonActions>
      </div>

      <div style={s.card}>
        <table style={s.table}>
          <thead>
            <tr>{['Número','Proyecto','Cliente','F. Emisión','F. Entrega','Lugar entrega','Estado','Cambiar estado','Imprimir'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={8} style={s.empty}>Sin remisiones registradas</td></tr>}
            {lista.map(r => (
              <tr key={r.id}>
                <td style={{ ...s.td, color:'#93c5fd', fontWeight:600 }}>{r.numero}</td>
                <td style={s.td}><p style={{ margin:0 }}>{r.proyecto_nombre}</p><p style={{ margin:0, color:'#64748b', fontSize:11 }}>{r.proyecto_codigo}</p></td>
                <td style={s.td}>{r.cliente_nombre}</td>
                <td style={s.td}>{new Date(r.created_at).toLocaleDateString('es-CO')}</td>
                <td style={s.td}>{r.fecha_entrega ? new Date(r.fecha_entrega).toLocaleDateString('es-CO') : '—'}</td>
                <td style={s.td}>{r.lugar_entrega || '—'}</td>
                <td style={s.td}><span style={{ ...s.badge, background:EC[r.estado]+'22', color:EC[r.estado] }}>{r.estado}</span></td>
                <td style={s.td}>
                  <select style={s.select} value={r.estado} onChange={e => cambiarEstado(r.id, e.target.value)}>
                    {ESTADOS.map(e => <option key={e} value={e}>{e}</option>)}
                  </select>
                </td>
                <td style={s.td}>
                  <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                    <button style={HIST_BTN} title="Editar remisión" onClick={() => abrirEditar(r)}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
                    </button>
                    <button style={HIST_BTN} title="Historial" onClick={() => setVerHist({ docTipo:'remision', docId: r.id, numero: r.numero })}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>
                    </button>
                    <button style={HIST_BTN} title="Sacar de bodega (descontar inventario)" onClick={() => setSalidaRem(r)}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21V8l9-5 9 5v13"/><path d="M3 21h18"/><path d="M12 11v6"/><path d="m9 14 3 3 3-3"/></svg>
                    </button>
                    <BotonesDocumento tipo="remision" datos={r} onPrint={() => handlePrintRemision(r)} onEmail={() => setEmailRem(r)} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:860 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>{editId ? 'Editar Remisión de Entrega' : 'Nueva Remisión de Entrega'}</h2><button style={s.closeBtn} onClick={() => { setModal(false); setEditId(null); }}>✕</button></div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Proyecto *</label>
                  <select style={s.input} value={form.proyecto_id} onChange={e => onProyecto(e.target.value)}>
                    <option value="">Seleccionar proyecto</option>
                    {proyectos.map(p => <option key={p.id} value={p.id}>{p.codigo} — {p.nombre}</option>)}
                  </select>
                </div>
                {selectedProy && <div style={s.field}><label style={s.label}>Cliente</label><input style={{ ...s.input, background:'#162032', color:'#64748b' }} value={selectedProy.cliente_nombre || ''} readOnly /></div>}
              </div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Fecha entrega</label><input style={s.input} type="date" value={form.fecha_entrega} onChange={e => setForm({...form, fecha_entrega:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Lugar de entrega</label><input style={s.input} value={form.lugar_entrega} onChange={e => setForm({...form, lugar_entrega:e.target.value})} placeholder="Dirección, ciudad..." /></div>
              </div>
              <div style={s.field}><label style={s.label}>Notas</label><textarea style={{ ...s.input, minHeight:50, resize:'vertical' }} value={form.notas} onChange={e => setForm({...form, notas:e.target.value})} /></div>

              <div style={s.itemsHeader}><span style={s.label}>Ítems a entregar</span><button style={s.btnSm} onClick={addItem}>+ Agregar ítem</button></div>
              {form.items.map((it, i) => (
                <div key={i} style={s.itemRow}>
                  <ProductoPicker value={it.descripcion} onChangeText={v => itemDescText(i, v)} onPick={p => itemPick(i, p)} style={{ ...s.itemCtrl, flex:3 }} placeholder="Descripción o buscar producto…" />
                  <input style={{ ...s.itemCtrl, flex:1 }} type="number" placeholder="Cant." value={it.cantidad} onChange={e => updateItem(i,'cantidad',e.target.value)} />
                  <input style={{ ...s.itemCtrl, flex:1 }} placeholder="Unidad" value={it.unidad} onChange={e => updateItem(i,'unidad',e.target.value)} />
                  <input style={{ ...s.itemCtrl, flex:2 }} placeholder="Observaciones" value={it.observaciones} onChange={e => updateItem(i,'observaciones',e.target.value)} />
                  {form.items.length > 1 && <button style={s.removeBtn} onClick={() => removeItem(i)}>✕</button>}
                </div>
              ))}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => { setModal(false); setEditId(null); }}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity:saving?0.7:1 }} onClick={handleCreate} disabled={saving}>{saving ? 'Guardando...' : (editId ? 'Guardar cambios' : 'Crear remisión')}</button>
            </div>
          </div>
        </div>
      )}
      {verHist && <DocHistorialModal {...verHist} onClose={() => setVerHist(null)} />}
      {salidaRem && <SalidaBodegaModal remision={salidaRem} onClose={() => { setSalidaRem(null); load(); }} onFlash={(ok, t) => { setFlash({ ok, t }); setTimeout(() => setFlash(null), 4500); }} />}
      {flash && <div style={{ position:'fixed', bottom:20, right:20, zIndex:60, padding:'12px 16px', borderRadius:10, fontSize:14, background: flash.ok ? '#064e3b' : '#3f1d1d', color: flash.ok ? '#6ee7b7' : '#fca5a5', border:'1px solid #334155' }}>{flash.t}</div>}
      {emailRem && (
        <ModalEmail
          tipo="remision"
          id={emailRem.id}
          clienteId={emailRem.cliente_id}
          onClose={() => setEmailRem(null)}
          onSent={load}
        />
      )}
    </div>
  );
}

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  btnSm:       { background:'#1e40af', color:'#93c5fd', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' },
  filtros:     { display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' },
  chip:        { background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', padding:'6px 14px', borderRadius:20, fontSize:12, cursor:'pointer' },
  chipActive:  { background:'#1d4ed8', borderColor:'#1d4ed8', color:'#fff' },
  card:        { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  table:       { width:'100%', borderCollapse:'collapse' },
  th:          { padding:'12px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032' },
  td:          { padding:'4px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332', verticalAlign:'top' },
  empty:       { padding:'32px', textAlign:'center', color:'#475569' },
  badge:       { padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 },
  select:      { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:6, padding:'3px 8px', fontSize:12, cursor:'pointer' },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:640, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px', overflowY:'auto', overflowX:'hidden', flex:1 },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  itemsHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 },
  itemRow:     { display:'flex', gap:8, alignItems:'center', marginBottom:8 },
  itemCtrl:    { minWidth:0, height:38, padding:'0 10px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  removeBtn:   { background:'#450a0a', border:'none', color:'#fca5a5', borderRadius:6, padding:'4px 8px', cursor:'pointer', fontSize:12 },
};
